export const Colors = {
  red: '#ff442e',
  blue: '#d6fdff',
  green: '#0de496',
  black: '#272b38',
  gray: '#a0a3aa',
};
